import { use } from "react"
import { NavigationContext } from "./NavigationContext"

export const useNavigationContext = () => {
  const context = use(NavigationContext)
  if (!context) {
    throw new Error(
      `useNavigationContext must be used within a NavigationProvider`
    )
  }
  return context
}
